import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUniqueVoucherReviewRatingHistory } from '@/shared/model/unique-voucher-review-rating-history.model';

const baseApiUrl = 'api/unique-voucher-review-rating-histories';
const baseSearchApiUrl = 'api/_search/unique-voucher-review-rating-histories?query=';

export default class UniqueVoucherReviewRatingHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUniqueVoucherReviewRatingHistory> {
    return new Promise<IUniqueVoucherReviewRatingHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUniqueVoucherReviewRatingHistory): Promise<IUniqueVoucherReviewRatingHistory> {
    return new Promise<IUniqueVoucherReviewRatingHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUniqueVoucherReviewRatingHistory): Promise<IUniqueVoucherReviewRatingHistory> {
    return new Promise<IUniqueVoucherReviewRatingHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
